export const saveAs = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
};

export const downloadFile = async (path: string) => {
  try {
    const response = await fetch(path);
    if (!response.ok) {
      throw new Error("Failed to download template file.");
    }
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error downloading file:", error);
    return undefined;
  }
};
